<ng-container *ngIf="state.state$ | async as draft; else loadingTpl">
    <div class="wizard-shell">
        <header class="wizard-header">
            <div class="wizard-title">
                <mat-icon class="wizard-icon">business</mat-icon>
                <h1>Create a new organization</h1>
                <span class="wizard-subtitle" *ngIf="draft.basics?.name as n">— {{ n }}</span>
            </div>

            <div class="wizard-meta">
                <span class="autosave-indicator" [attr.data-status]="saveStatus" [ngSwitch]="saveStatus">
                    <ng-container *ngSwitchCase="'dirty'">
                        <mat-icon inline>edit</mat-icon> unsaved changes
                    </ng-container>
                    <ng-container *ngSwitchCase="'saving'">
                        <mat-icon inline class="spin">autorenew</mat-icon> saving…
                    </ng-container>
                    <ng-container *ngSwitchCase="'saved'"> <mat-icon inline>cloud_done</mat-icon> saved </ng-container>
                    <ng-container *ngSwitchCase="'error'">
                        <mat-icon inline>cloud_off</mat-icon> save failed
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <ng-container *ngIf="lastSavedAt"> <mat-icon inline>cloud_done</mat-icon> saved </ng-container>
                    </ng-container>
                </span>
                <button mat-icon-button (click)="state.undo()" [disabled]="!state.canUndo()" title="Undo">
                    <mat-icon>undo</mat-icon>
                </button>
                <button mat-icon-button (click)="state.redo()" [disabled]="!state.canRedo()" title="Redo">
                    <mat-icon>redo</mat-icon>
                </button>
                <button mat-icon-button (click)="closeWizard()" title="Close (autosaved)">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </header>

        <nav class="wizard-stepper">
            <ng-container *ngFor="let s of stepNumbers; let i = index">
                <button
                    class="step-btn"
                    [class.active]="draft.currentStep === s"
                    [class.done]="draft.currentStep > s"
                    (click)="goToStep(s)"
                >
                    <span class="step-num">{{ s }}</span>
                    <span class="step-label">
                        <ng-container [ngSwitch]="s">
                            <ng-container *ngSwitchCase="1">Source</ng-container>
                            <ng-container *ngSwitchCase="2">Basics</ng-container>
                            <ng-container *ngSwitchCase="3">Structure</ng-container>
                            <ng-container *ngSwitchCase="4">Staff</ng-container>
                            <ng-container *ngSwitchCase="5">Plan &amp; Features</ng-container>
                            <ng-container *ngSwitchCase="6">Review</ng-container>
                        </ng-container>
                    </span>
                </button>
            </ng-container>
        </nav>

        <main class="wizard-body" [ngSwitch]="draft.currentStep">
            <newgenus-org-creation-step-source *ngSwitchCase="1"></newgenus-org-creation-step-source>
            <newgenus-org-creation-step-basics *ngSwitchCase="2"></newgenus-org-creation-step-basics>

            <newgenus-org-creation-step-structure *ngSwitchCase="3"></newgenus-org-creation-step-structure>

            <newgenus-org-creation-step-staff *ngSwitchCase="4"></newgenus-org-creation-step-staff>

            <newgenus-org-creation-step-features *ngSwitchCase="5"></newgenus-org-creation-step-features>

            <newgenus-org-creation-step-review
                *ngSwitchCase="6"
                [draftKey]="draft.key"
                [submitting]="submitting"
                [errorMessage]="errorMessage"
                (submitDraft)="submit(draft)"
            ></newgenus-org-creation-step-review>
        </main>

        <footer class="wizard-footer">
            <button mat-button (click)="previous()" [disabled]="draft.currentStep === 1">
                <mat-icon>chevron_left</mat-icon> Back
            </button>
            <span class="footer-status" *ngIf="draft.currentStep !== 6"> Step {{ draft.currentStep }} of 6 </span>
            <button
                *ngIf="draft.currentStep !== 6"
                mat-raised-button
                color="primary"
                (click)="next()"
                [disabled]="!canAdvanceFrom(draft.currentStep, draft)"
            >
                Next <mat-icon>chevron_right</mat-icon>
            </button>
        </footer>
    </div>
</ng-container>

<ng-template #loadingTpl>
    <div class="wizard-loading" *ngIf="!errorMessage; else errorTpl">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading wizard…</p>
    </div>
    <ng-template #errorTpl>
        <div class="wizard-error">
            <mat-icon color="warn">error_outline</mat-icon>
            <p>{{ errorMessage }}</p>
            <button mat-stroked-button color="primary" (click)="closeWizard()">Back to dashboard</button>
        </div>
    </ng-template>
</ng-template>
